import type * as z from 'zod/v4';

export type Issue = {
  code: z.ZodError['issues'][number]['code'];
  path: string;
  message: string;
};

/**
 * Format Zod errors to a more compact format.
 * Ideal for logging.
 *
 * @param issue Zod issue
 * @returns Compact issue collection
 */
export function formatIssue(issue: z.ZodError['issues'][number]): Issue & { issues: Issue[] } {
  let subIssueError: Issue[] = [];
  const messages = [issue.message];

  if (issue.code === 'invalid_union') {
    subIssueError = issue.errors.flat().map((e) => formatIssue(e));
  }
  if (issue.code === 'unrecognized_keys') {
    messages.push(issue.keys.join(','));
  }

  return {
    code: issue.code,
    path: issue.path.join('.'),
    message: messages.join(', '),
    issues: subIssueError,
  };
}
